import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { GeneralResponse, Token } from "../../../types/api";
import { Methods } from "../../constants/CommonConstants";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { IProfileChangePhoneNumberRequest } from "../../../types/apis/profile";

export const ProfileChangePhoneNumberVerify = async (data: {
  payload: IProfileChangePhoneNumberRequest;
  token: Token;
}): Promise<GeneralResponse> => {
  const { payload, token } = data;
  try {
    const response = await Api<
      any,
      GeneralResponse<IProfileChangePhoneNumberRequest>
    >({
      method: Methods.POST,
      endpoint: EndPoints.profileChangePhoneNumberVerify,
      body: payload,
      token,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useProfileChangePhoneNumberVerify = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    { payload: IProfileChangePhoneNumberRequest; token: Token }
  > = useMutation({
    mutationFn: ProfileChangePhoneNumberVerify,
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
